import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../design/Button';
import { useSchoolAuth } from '../auth/SchoolAuthContext';

interface UnauthorizedPageProps {
  email: string | null;
}

const UnauthorizedPage: React.FC<UnauthorizedPageProps> = ({ email }) => {
  const { t } = useTranslation();
  const { signOut } = useSchoolAuth();

  const handleSignOut = async (): Promise<void> => {
    try {
      await signOut();
    } catch (err) {
      console.error('[school] signOut failed', err);
    }
  };

  return (
    <div className="flex min-h-0 flex-1 items-center justify-center overflow-y-auto bg-school-canvas px-4 py-10">
      <div className="w-full max-w-md rounded-3xl bg-school-surface p-8 text-center shadow-md">
        <h1 className="mb-3 text-xl font-bold text-school-ink">{t('school_unauthorized_title')}</h1>
        <p className="mb-6 text-sm text-school-muted">
          {t('school_unauthorized_message', { email: email ?? '' })}
        </p>
        <Button variant="secondary" icon="logout" onClick={handleSignOut}>
          {t('school_sign_out')}
        </Button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
